var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nav","v-on":_vm.check_browser()}},[_c('intro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }